module.exports = __webpack_public_path__ + "img/documents.34c84e10.svg";